import styled from "styled-components";

export const Container = styled.div`
  margin-top: 2.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Header = styled.h2`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 6px;
`;

type StatusImpressaoTipo = "PENDENTE" | "IMPRIMINDO" | "IMPRESSO" | "ERRO";

const tagStyleStrategy: Record<StatusImpressaoTipo, { background: string; color: string }> = {
  PENDENTE: { background: "#FFF8E1", color: "#F59E0B" },
  IMPRIMINDO: { background: "#E0F2FE", color: "#0284C7" },
  IMPRESSO: { background: "#D1FAE5", color: "#059669" },
  ERRO: { background: "#FFE4E4", color: "#EE5353" },
};

interface TagProps {
  tipo: StatusImpressaoTipo;
}

export const Tag = styled.div<TagProps>`
  background-color: ${({ tipo }) => tagStyleStrategy[tipo].background};
  border: 1px solid ${({ tipo }) => tagStyleStrategy[tipo].color};
  border-radius: 50px;
  color: ${({ tipo }) => tagStyleStrategy[tipo].color};
  padding: 5px 8px;
  text-align: center;
  width: 110px;
`;
